import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Briefcase, MapPin, DollarSign, Users, Save, AlertCircle } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/Card';
import { Input } from '../components/ui/Input';
import { Select } from '../components/ui/Select';
import { useAuth } from '../contexts/AuthContext';
export function CreateJobPage() {
  const navigate = useNavigate();
  const {
    user
  } = useAuth();
  const [formData, setFormData] = useState({
    title: '',
    type: 'full-time',
    location: '',
    locationType: 'office',
    salaryMin: '',
    salaryMax: '',
    experience: '',
    education: '',
    description: '',
    requirements: '',
    responsibilities: '',
    benefits: '',
    skills: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    alert('Lowongan berhasil dibuat!');
    navigate('/company/jobs');
  };
  return <div className="min-h-screen bg-white" data-id="element-2230">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-2231">
        {/* Header */}
        <div className="mb-8" data-id="element-2232">
          <Button variant="ghost" onClick={() => navigate('/company/jobs')} className="mb-4" data-id="element-2233">
            <ArrowLeft className="w-4 h-4 mr-2" data-id="element-2234" />
            Kembali ke Daftar Lowongan
          </Button>
          <h1 className="text-3xl font-semibold text-neutral-900 mb-2" data-id="element-2235">
            Buat Lowongan Kerja Baru
          </h1>
          <p className="text-neutral-600" data-id="element-2236">
            Lengkapi informasi lowongan kerja Anda
          </p>
        </div>

        {/* Info Alert */}
        <Card className="mb-6 bg-atios-light border-atios-primary/20" data-id="element-2237">
          <CardContent className="p-4" data-id="element-2238">
            <div className="flex gap-3" data-id="element-2239">
              <AlertCircle className="w-5 h-5 text-atios-primary flex-shrink-0 mt-0.5" data-id="element-2240" />
              <div className="text-sm text-neutral-700" data-id="element-2241">
                <p className="font-medium mb-1" data-id="element-2242">
                  Tips Membuat Lowongan Efektif
                </p>
                <ul className="list-disc list-inside space-y-1 text-neutral-600" data-id="element-2243">
                  <li data-id="element-2244">Tulis deskripsi pekerjaan yang jelas dan detail</li>
                  <li data-id="element-2245">Cantumkan range gaji yang kompetitif</li>
                  <li data-id="element-2246">Sebutkan benefit dan fasilitas yang ditawarkan</li>
                </ul>
              </div>
            </div>
          </CardContent>
        </Card>

        <form onSubmit={handleSubmit} className="space-y-6" data-id="element-2247">
          {/* Basic Information */}
          <Card data-id="element-2248">
            <CardHeader data-id="element-2249">
              <CardTitle data-id="element-2250">Informasi Dasar</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4" data-id="element-2251">
              <Input label="Judul Posisi" required value={formData.title} onChange={e => setFormData({
              ...formData,
              title: e.target.value
            })} placeholder="Senior Backend Developer" data-id="element-2252" />

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-2253">
                <Select label="Tipe Pekerjaan" required value={formData.type} onChange={e => setFormData({
                ...formData,
                type: e.target.value
              })} data-id="element-2254">
                  <option value="full-time" data-id="element-2255">Full-time</option>
                  <option value="part-time" data-id="element-2256">Part-time</option>
                  <option value="contract" data-id="element-2257">Contract</option>
                  <option value="freelance" data-id="element-2258">Freelance</option>
                  <option value="internship" data-id="element-2259">Internship</option>
                </Select>

                <Select label="Lokasi Kerja" required value={formData.locationType} onChange={e => setFormData({
                ...formData,
                locationType: e.target.value
              })} data-id="element-2260">
                  <option value="office" data-id="element-2261">Office</option>
                  <option value="remote" data-id="element-2262">Remote</option>
                  <option value="hybrid" data-id="element-2263">Hybrid</option>
                </Select>
              </div>

              <Input label="Lokasi" required value={formData.location} onChange={e => setFormData({
              ...formData,
              location: e.target.value
            })} placeholder="Jakarta, Indonesia" data-id="element-2264" />
            </CardContent>
          </Card>

          {/* Salary & Requirements */}
          <Card data-id="element-2265">
            <CardHeader data-id="element-2266">
              <CardTitle data-id="element-2267">Gaji & Persyaratan</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4" data-id="element-2268">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-2269">
                <Input label="Gaji Minimum (Rp)" type="number" required value={formData.salaryMin} onChange={e => setFormData({
                ...formData,
                salaryMin: e.target.value
              })} placeholder="15000000" data-id="element-2270" />
                <Input label="Gaji Maksimum (Rp)" type="number" required value={formData.salaryMax} onChange={e => setFormData({
                ...formData,
                salaryMax: e.target.value
              })} placeholder="20000000" data-id="element-2271" />
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-2272">
                <Input label="Pengalaman (tahun)" required value={formData.experience} onChange={e => setFormData({
                ...formData,
                experience: e.target.value
              })} placeholder="3-5 tahun" data-id="element-2273" />
                <Input label="Pendidikan" required value={formData.education} onChange={e => setFormData({
                ...formData,
                education: e.target.value
              })} placeholder="S1 Teknik Informatika" data-id="element-2274" />
              </div>
            </CardContent>
          </Card>

          {/* Job Details */}
          <Card data-id="element-2275">
            <CardHeader data-id="element-2276">
              <CardTitle data-id="element-2277">Detail Pekerjaan</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4" data-id="element-2278">
              <div data-id="element-2279">
                <label className="text-sm font-medium text-neutral-900 block mb-2" data-id="element-2280">
                  Deskripsi Pekerjaan
                </label>
                <textarea required value={formData.description} onChange={e => setFormData({
                ...formData,
                description: e.target.value
              })} className="w-full min-h-[120px] rounded-lg border border-neutral-300 bg-white px-4 py-3 text-sm text-neutral-900 placeholder:text-neutral-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-atios-primary" placeholder="Jelaskan tentang posisi ini..." data-id="element-2281" />
              </div>

              <div data-id="element-2282">
                <label className="text-sm font-medium text-neutral-900 block mb-2" data-id="element-2283">
                  Persyaratan
                </label>
                <textarea required value={formData.requirements} onChange={e => setFormData({
                ...formData,
                requirements: e.target.value
              })} className="w-full min-h-[100px] rounded-lg border border-neutral-300 bg-white px-4 py-3 text-sm text-neutral-900 placeholder:text-neutral-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-atios-primary" placeholder="- Minimal 3 tahun pengalaman&#10;- Menguasai Node.js&#10;- Dll" data-id="element-2284" />
              </div>

              <div data-id="element-2285">
                <label className="text-sm font-medium text-neutral-900 block mb-2" data-id="element-2286">
                  Tanggung Jawab
                </label>
                <textarea required value={formData.responsibilities} onChange={e => setFormData({
                ...formData,
                responsibilities: e.target.value
              })} className="w-full min-h-[100px] rounded-lg border border-neutral-300 bg-white px-4 py-3 text-sm text-neutral-900 placeholder:text-neutral-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-atios-primary" placeholder="- Mengembangkan API&#10;- Code review&#10;- Dll" data-id="element-2287" />
              </div>

              <div data-id="element-2288">
                <label className="text-sm font-medium text-neutral-900 block mb-2" data-id="element-2289">
                  Benefit
                </label>
                <textarea value={formData.benefits} onChange={e => setFormData({
                ...formData,
                benefits: e.target.value
              })} className="w-full min-h-[80px] rounded-lg border border-neutral-300 bg-white px-4 py-3 text-sm text-neutral-900 placeholder:text-neutral-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-atios-primary" placeholder="- BPJS Kesehatan&#10;- Asuransi&#10;- Dll" data-id="element-2290" />
              </div>

              <Input label="Skills yang Dibutuhkan (pisahkan dengan koma)" required value={formData.skills} onChange={e => setFormData({
              ...formData,
              skills: e.target.value
            })} placeholder="Node.js, PostgreSQL, Docker, AWS" data-id="element-2291" />
            </CardContent>
          </Card>

          {/* Action Buttons */}
          <div className="flex gap-4" data-id="element-2292">
            <Button type="button" variant="secondary" onClick={() => navigate('/company/jobs')} className="flex-1" data-id="element-2293">
              Batal
            </Button>
            <Button type="submit" className="flex-1" data-id="element-2294">
              <Save className="w-4 h-4 mr-2" data-id="element-2295" />
              Publikasikan Lowongan
            </Button>
          </div>
        </form>
      </div>
    </div>;
}